import { render, staticRenderFns } from "./BudgetPage.vue?vue&type=template&id=331c25a1&scoped=true"
import script from "./BudgetPage.vue?vue&type=script&lang=js"
export * from "./BudgetPage.vue?vue&type=script&lang=js"
import style0 from "./BudgetPage.vue?vue&type=style&index=0&id=331c25a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c25a1",
  null
  
)

export default component.exports